import {BzAuthorizationDetailComponent} from './authorization-detail/authorization-detail.component';
import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthorizationService} from 'app/security/core/services/authorization.service';
import {SecurityService} from 'app/security/core/services/security.service';
import {AuthorizationTree} from 'app/security/core/models/authorization.tree';
import {AuthorizationChildNode} from 'app/security/core/models/authorization.child-node';
import {TreeModel} from 'app/shared/components/tree/tree-model';
import * as _ from 'lodash';
import {BzgModalService, BzgToastService} from 'bz-genome-angular';
import {PendingChangesConfirmationComponent} from '../../shared/components/pending-changes-confirmation/pending-changes-confirmation.component';
import {EAuthorizationItemType} from '../core/models/enum/security.enum';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'security-authorization',
  templateUrl: 'security-authorization.component.html',
  styleUrls: ['security-authorization.component.scss']
})
export class SecurityAuthorizationComponent implements OnInit {

  @ViewChild('authDetailComponent', { static: false}) authDetailComponent: BzAuthorizationDetailComponent;

  public _treeParent: TreeModel[] = [];
  public authorizationDetail: IAuthorizationDetail;
  public currentAuthorizationType: string;
  public detailName: string;

  public nodeId: string;
  public showDetail: boolean;
  public isLoadingNodes: boolean;
  public isLoadingData: boolean;
  public isEmpty = false;

  public currentValue: string;
  public currentParentId: string;
  private usersRolesStakeholders = {};
  private listExcludedItems = ['UserDelegates']

  selectedComponent: any;
  infoEvent: any;

  constructor(private authServices: AuthorizationService,
              private securityService: SecurityService,
              private _modalService: BzgModalService,
              private _toastService: BzgToastService,
              private _i18nService: I18nService
  ) { }

  ngOnInit() {
    this.isLoadingNodes = true;
    this.showDetail = false;

    this.authServices.getParentsTree().subscribe((response) => {
      const treeParent: AuthorizationTree[] = response;

      _.forEach(treeParent, (each) => {
        const _treeItem: TreeModel = {
          id: each.Id ? each.Id : '',
          parentId: '',
          value: 'AUTHORIZATION_TREE.' + (each.DisplayName ? each.DisplayName : ''),
          type: each.DisplayName ? each.DisplayName : '',
          iconClass: '#key',
          hasNodes: true,
          children: new Array<TreeModel>(),
          isDetail: false,
          isExpanded: false,
          isSelected: false
        };

        this._treeParent.push(_treeItem);
        this.getChild(_treeItem, each.Nodes);
      });

      this.isLoadingNodes = false;
    }, (error) => {
      this.isLoadingNodes = false;
      this._toastService.open( 'An error has occurred',
        {
          type: 'warning',
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });

    this.getDataUserRolesStakeholders();
  }

  getDataUserRolesStakeholders() {
    this.securityService.getParameters('Groups').subscribe((response) => {
      this.usersRolesStakeholders[EAuthorizationItemType.UserGroup] = response;
    });
    this.securityService.getParameters('Roles').subscribe((response) => {
      this.usersRolesStakeholders[EAuthorizationItemType.Role] = response;
    });
    this.securityService.getParameters('Stakeholders').subscribe((response) => {
      this.usersRolesStakeholders[EAuthorizationItemType.Stakeholder] = response;
    });
  }

  onChildClick(e: any) {
    this.showDetail = false;
    const match: number = Number(e.value);
    if (e.isDetail && isNaN(match)) {
      if (this.authDetailComponent && this.authDetailComponent.isThereAnyPendingChange()) {
        this.showDialogPendingChanges(e, this.authDetailComponent);
      }
      else {
        this.getDetail(e);
      }
      this.isEmpty = false;
    } else {
      this.isEmpty = true;
    }
  }

  showDialogPendingChanges(e: any, component: any) {
    this.selectedComponent = component;
    this.infoEvent = e;
    const deleteModal =  this._modalService.open(PendingChangesConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {title: 'GLOBAL.CONFIRMATION',
        message: 'GLOBAL.PENDING_CHANGES'
      }});
    deleteModal.afterClosed().subscribe((result: string) => {
      if (result === 'save') {
        this.selectedComponent.save(false).subscribe(response => {
          this.getDetail(this.infoEvent);
        });
      }
      else {
        this.getDetail(this.infoEvent);
      }
    })
  }

  private _getSubType(grandParentDisplayName: string, parentDisplayName: string): string {
    return grandParentDisplayName === 'ManageProfiles' ? parentDisplayName : grandParentDisplayName;
  }

  getChild(e: any, response: any) {
    if (e.isDetail || e.hasNodes || e.children.length > 0) {
      this.isLoadingNodes = true;

      this.isLoadingNodes = false;

      let treeChild: TreeModel[] = [];
      const treeNodes: AuthorizationChildNode[] = response;
      const isDetail = true;

      if (treeNodes && treeNodes.length > 0) {
        _.forEach(treeNodes, (each) => {
          const treeChildNode: TreeModel[] = [];

          if (each.Nodes && each.Nodes.length > 0 && e.type !== 'Applications') {
            _.forEach(each.Nodes, (eachNode, i) => {
              if (e && e.type === 'Vocabulary' && eachNode && eachNode.DisplayName === 'APPLICATION_VOCABULARY')
                eachNode.DisplayName = this._i18nService.instant('AUTHORIZATION.APPLICATION_VOCABULARY');

              const treeChildNodeChild: TreeModel[] = [];

              if (!this.isValidNode(eachNode)) {
                each.Nodes.slice(i, 1);
                return;
              }

              if (eachNode.Nodes && eachNode.Nodes.length > 0) {
                _.forEach(eachNode.Nodes, (eachChildNode) => {
                  const treeChildNodeDetail: TreeModel[] = [];

                  if (eachChildNode.Nodes && eachChildNode.Nodes.length > 0) {
                    _.forEach(eachChildNode.Nodes, (eachChildNodeDetail) => {
                      const _treeChildNodeDetail: TreeModel = {
                        id: eachChildNodeDetail.Id,
                        parentId: eachChildNode.Id ? eachChildNode.Id : '',
                        value: 'AUTHORIZATION_TREE.' + (eachChildNodeDetail.DisplayName),
                        type: e.type ? e.type : each.subType,
                        subType: e.type === 'Manage' ? this._getSubType(each.DisplayName, eachNode.DisplayName) : '',
                        iconClass: '#keys',
                        hasNodes: false,
                        children: new Array<TreeModel>(),
                        isDetail: true,
                        isExpanded: false,
                        isSelected: false,
                        level: 4
                      };
                      treeChildNodeDetail.push(_treeChildNodeDetail);
                    });
                  }
                  const isDetail: boolean = (eachChildNode.Id && eachChildNode.Nodes.length === 0) || (e.type === 'Analysis' || e.type === 'Manage' || (e.type === 'Policy' && eachChildNode.Nodes.length > 0));
                  const _treeChildNodeChild: TreeModel = {
                    id: eachChildNode.Id,
                    parentId: eachNode.Id ? eachNode.Id : '',
                    value: 'AUTHORIZATION_TREE.' + (eachChildNode.DisplayName),
                    type: e.type ? e.type : each.subType,
                    subType: e.type === 'Manage' ? this._getSubType(each.DisplayName, eachNode.DisplayName) : '',
                    iconClass: treeChildNodeDetail.length > 0 ? '#key' : '#keys',
                    hasNodes: treeChildNodeDetail.length > 0,
                    children: treeChildNodeDetail,
                    isDetail,
                    isExpanded: false,
                    isSelected: false,
                    level: 3
                  };

                  treeChildNodeChild.push(_treeChildNodeChild);
                });
              }
              const isDetail = (e.type === 'WfClass' ||
                e.type === 'Pages' ||
                (e.type === 'Policy' && treeChildNodeChild.length <= 0) ||
                e.type === 'QueryForms' ||
                e.type === 'Stakeholders' ||
                e.type === 'SOAServices' ||
                e.type === 'RPACallback' ||
                e.type === 'Vocabulary'
              );

              const _treeChildNode: TreeModel = {
                id: eachNode.Id,
                parentId: each.Id ? each.Id : '',
                value: 'AUTHORIZATION_TREE.' + (eachNode.DisplayName),
                type: e.type ? e.type : '',
                iconClass: treeChildNodeChild.length > 0 ? '#key' : '#keys',
                hasNodes: treeChildNodeChild.length > 0,        /** */
                children: treeChildNodeChild,
                isDetail,
                isExpanded: false,
                isSelected: false,
                level: 2
              };

              treeChildNode.push(_treeChildNode);
            });
          }

          const isDetail =
            e.type === 'Applications' ||
            e.type === 'ParametricEntities' ||
            (e.type === 'Vocabulary' && each.Nodes.length === 0) ||
            e.type === 'Stakeholders' ||
            e.type === 'QueryForms';

          const _treeChild: TreeModel = {
            id: each.Id ? each.Id : '',
            parentId: '',
            value: 'AUTHORIZATION_TREE.' + (each.DisplayName ? each.DisplayName : ''),
            type: e.type ? e.type : '',
            iconClass: treeChildNode.length > 0 ? '#key' : '#keys',
            hasNodes: treeChildNode.length > 0,
            children: treeChildNode,
            isDetail,
            isExpanded: false,
            isSelected: false,
            level: 1
          };

          treeChild.push(_treeChild);
        });

        if (e.type === 'Stakeholders') {
          treeChild = _.orderBy(treeChild, ['value'], ['asc']);
        }

        if (e && e.type === 'Vocabulary') {
          treeChild.forEach(child => {
            if (child.children)
              child.children = _.orderBy(child.children, ['value'], ['asc']);
          });
        }

        const newTree: any = _.find(this._treeParent, { value: e.value });
        if (newTree && newTree.children) {
          newTree.children = treeChild;
        }
      }
      else {
        const newTree: any = _.find(this._treeParent, { value: e.value });
        newTree.hasNodes = false;
      }
    }
  }

  isValidNode(node) {
    let result = true;
    this.listExcludedItems.forEach(element => {
      if (node.DisplayName === element) {
        result = false;
        return;
      }
    });
    return result;
  };

  getDetail(e: any) {
    this.isLoadingData = true;
    this.showDetail = true;
    this.nodeId = e.id;
    this.detailName = e.value;
    this.currentValue = e.id;
    this.currentParentId = e.type;

    const type = e.type === '' ? e.value : e.type;
    this.currentAuthorizationType = type;

    this.isLoadingData = false;

    this.authServices.getAuthorizationDetail(type, e.subType, e.id).subscribe((response: IAuthorizationDetail) => {
      this.authorizationDetail = response;
    }, (error) => {
      this._toastService.open( 'An error has occurred',
        {
          type: 'warning',
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
    });
  }
}
